import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { flashMessage } from 'redux-flash';

import { sportsAuthorityService } from '../../services';

const passwordManagementSlice = createSlice({
  name: 'passwordManagement',
  initialState: {
    loading: false,
    error: null,
    success: false,
    message: null,
    token: null
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    resetPasswordState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(forgotPassword.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(forgotPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action?.payload?.message;
    });
    builder.addCase(forgotPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error?.message;
      state.success = true;
    });
    builder.addCase(resetPassword.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action?.payload?.message;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.loading = false;
      console.log(action.error);
      state.error = action.error?.message.includes('code 410')
        ? String.raw`\Password reset token has expired`
        : action.error.message;
      state.success = false;
    });
  }
});

export const { setLoading, setToken, resetPasswordState } = passwordManagementSlice.actions;
export const selectLoading = (state) => state.passwordManagement.loading;
export const selectError = (state) => state.passwordManagement.error;

export const selectSuccess = (state) => state.passwordManagement.success;
export const selectMessage = (state) => state.passwordManagement.message;
export const selectToken = (state) => state.passwordManagement.token;
export default passwordManagementSlice.reducer;

export const forgotPassword = createAsyncThunk(
  'passwordManagement/forgotPassword',
  async (email, { dispatch }) => {
    if (!email) {
      throw new Error('Email is required');
    }

    let response;

    try {
      response = await sportsAuthorityService.forgotPassword(email);
    } catch (error) {
      // return rejectWithValue({ error });
      console.error(error);
    }

    console.log('Response:', response);

    // if (response?.status === '404') {
    //   return rejectWithValue({
    //     message: 'Email not found',
    //     statusCode: response.status
    //   });
    // }

    dispatch(
      flashMessage(
        "If an account with that email exists, we've sent a password reset link to it.",
        { isError: false, timeout: false }
      )
    );

    return response?.data;
  }
);

export const resetPassword = createAsyncThunk(
  'passwordManagement/resetPassword',
  async ({ newPassword, token: clientToken }, { getState, rejectWithValue, dispatch }) => {
    const token = selectToken(getState());
    if (!token && !clientToken) {
      throw new Error('Token is required');
    }

    try {
      const response = await sportsAuthorityService.resetPassword(
        token || clientToken,
        newPassword
      );
      return response?.data;
    } catch (error) {
      // Extract the error message from the API response
      const errorMessage = error.response?.data?.error || 'Failed to reset password';
      dispatch(
        flashMessage(errorMessage, {
          isError: true,
          timeout: 10_000
        })
      );
      return rejectWithValue({ error: errorMessage });
    }
  }
);
